import React from "react";
import { Box, CircularProgress, Stack, Typography } from "@mui/material";
import { ref, update } from "firebase/database";
import { rtdb } from "../../firebase";
import { CheckCircle } from "@mui/icons-material";
import theme from "../../assets/theme/theme";

export const ExpertHelpPaymentSuccess = function () {
  const [loadingManageBilling, setLoadingManageBilling] = React.useState(false);

  const makePaymentStatusSuccess = React.useCallback(async (queryId, uid) => {
    if (!queryId || !uid) return;
    try {
      setLoadingManageBilling(true);
      // update the payment status to success using rtdb
      const refStr = `immigration_queries/${uid}/${queryId}`;
      const immigrationQueriesRef = ref(rtdb, refStr);
      await update(
        immigrationQueriesRef,
        {
          payment_status: "completed",
        }
      );
      setLoadingManageBilling(false);
    } catch (error: any) {
      console.error(error);
      setLoadingManageBilling(false);
    }
  }, []);

  React.useEffect(() => {
    // Check to see if this is a redirect back from Checkout
    const query = new URLSearchParams(window.location.search);
    if (query.get("query_id") && query.get("uid")) {
      makePaymentStatusSuccess(query.get("query_id"), query.get("uid")); // replace "userId" with the actual user ID
    }
  }, [makePaymentStatusSuccess]);
  return (
    <Stack
      margin={8}
      direction="column"
      justifyContent="center"
      alignItems="center"
      spacing={2}
      textAlign={"center"}
    >
      {!loadingManageBilling ? (
        <Box>
          <CheckCircle fontSize="large" sx={{color: theme.palette.success.main, mb: 2}} />
          <Typography variant="h3" component="h3" fontSize={18}>
            Your payment is confirmed, and your query is now being processed.
          </Typography>
          <Typography variant="h3" component="h3" fontSize={18}>
            Welcome to a world of convenience and premium services!
          </Typography>
        </Box>
      ) : (
        <CircularProgress />
      )}
    </Stack>
  );
};
